import React, { useCallback } from 'react';
import type { GlobalProps } from '@bloomberg/media-ui-core';
import {
  classes,
  RoundedToggleButton,
  useSlug,
} from '@bloomberg/media-ui-core';

import styles from './QuickAddRoundedToggle.module.css';

export type QuickAddRoundedToggleProps = GlobalProps & {
  isFollowing?: boolean;
  onClick?: () => void;
  trackingFunction?: () => void;
};

export const QuickAddRoundedToggle = React.forwardRef<
  HTMLDivElement,
  QuickAddRoundedToggleProps
>(function QuickAddRoundedToggleComponent(
  props: QuickAddRoundedToggleProps,
  ref
) {
  const {
    name = 'quick-add-rounded-toggle',
    isFollowing = false,
    onClick = null,
    trackingFunction = () => {},
  } = props;

  const componentName = useSlug(name);

  const cx = classes([styles.quickAddRoundedToggle], {
    ...props,
    name,
  });

  const handleOnClick = useCallback(() => {
    trackingFunction?.();
    onClick?.();
  }, [onClick, trackingFunction]);

  return (
    <div
      className={cx}
      ref={ref}
      data-component={componentName}
      onClick={handleOnClick}
    >
      <RoundedToggleButton
        active={isFollowing}
        activeText="Following"
        inactiveText="Follow"
        title={isFollowing ? 'Following' : 'Follow'}
        withIcon
      />
    </div>
  );
});
